<ng-container [formGroup]="fieldParameters.sectionsContainer.formGroup">
  <mat-radio-group
    [formControlName]="formControlName"
    (change)="onChange($event)"
  >
    @for (opt of getFieldOptions(); track opt.value) {
      <mat-radio-button
        [value]="opt.value"
        class="radio-option"
      >
        {{opt.label | translate}}
      </mat-radio-button>
    }
  </mat-radio-group>
</ng-container>
